
export const common = {
  "404": "404",
  "This page has not been generated": "このページはまだ生成されていません",
  "Tell me what you would like on this page": "このページに何を表示したいか教えてください",
  "Please switch pages in the dropdown menu above": "上のドロップダウンメニューでページを切り替えてください",
  
  // Hero Section
  "Learn English Through Action Sports": "アクションスポーツで英語を学ぼう",
  "Master English with BMX & Skateboarding": "BMX・スケートボードで英語をマスター",
  "Join our unique online English conversation classes where you'll learn through the exciting world of BMX and skateboarding. Perfect for action sports enthusiasts who want to improve their English skills!": "日本初のオンライン英語スクール。スケートボードやBMXライダー向けに作られています。海外でライドしたり、世界中のスケート/BMXコミュニティとつながりたい人のためのスクールです。",
  "Start Free Trial": "無料体験を予約",
  "View Courses": "コースを見る",
  
  // Features Section
  "Why Choose Action English?": "なぜランプアップイングリッシュを選ぶのか？",
  "Interactive Learning": "実践的なレッスン",
  "Learn English through real BMX and skateboarding scenarios, making lessons engaging and memorable.": "楽しく実践的なレッスンでは、日常会話の英語、スケート用語、旅行で使えるフレーズ、BMXトリックの英語まで、スケートパークの雰囲気そのままに学べます。",
  "Expert Instructors": "経験豊富な講師",
  "Our native English-speaking instructors are also passionate action sports enthusiasts.": "NY出身でロサンゼルス育ち、BMXライダーとして We The People と Madera BMX Company にスポンサーされた経験を持つ講師が指導します。",
  "Flexible Schedule": "柔軟なスケジュール",
  "Take classes anytime, anywhere with our online platform designed for busy lifestyles.": "月曜から土曜、毎日10時~21時の間で生徒さんのご都合に合わせてクラスを設けております。",
  "Community Focus": "マンツーマン指導",
  "Connect with fellow action sports lovers while improving your English communication skills.": "すべてマンツーマンレッスン。レッスン中はもちろん、普段の学習面まできっちりメニューを作り、話せるようになるためのコーチングを行います。",
  
  // Courses Section
  "Our Courses": "レッスン内容",
  "BMX English Basics": "日常会話英語",
  "Learn fundamental English vocabulary and phrases used in BMX riding, from basic tricks to advanced techniques.": "アメリカで現地のライダーと話したり、公園でフードを注文したりする際に使える実践的な英語を学びます。",
  "Skateboard Conversations": "スケート用語",
  "Master conversational English through skateboarding culture, street terminology, and skate park interactions.": "スケートパークでのコミュニケーションに必要な専門用語や表現を習得します。",
  "Action Sports Media": "旅行英語",
  "Improve your English by analyzing action sports videos, interviews, and social media content.": "海外でのライディング旅行で役立つフレーズや表現を身につけます。",
  "Competition English": "BMXトリック英語",
  "Learn specialized English for competitions, judging criteria, and professional action sports communication.": "トリックを撮影してSNSでシェアする際に使える英語表現を学びます。",
  
  // Pricing Section
  "Choose Your Plan": "料金プラン",
  "Basic": "月4回コース",
  "Perfect for beginners": "初心者におすすめ",
  "2 classes per month": "月4回のレッスン",
  "Access to basic materials": "レッスン時間：40分",
  "Community forum access": "マンツーマン指導",
  "Pro": "月8回コース",
  "Most popular choice": "最も人気",
  "8 classes per month": "月8回のレッスン",
  "All course materials": "レッスン時間：40分",
  "1-on-1 sessions available": "3ヶ月間繰越可能",
  "Priority support": "マンツーマン指導",
  "Elite": "カスタムプラン",
  "For serious learners": "上級者向け",
  "Unlimited classes": "回数相談可能",
  "Personal learning plan": "個別学習プラン",
  "Weekly 1-on-1 coaching": "集中コーチング",
  "Exclusive content access": "特別サポート",
  "Get Started": "始める",
  "¥14,000": "¥14,000",
  "¥28,000": "¥28,000",
  "Contact for pricing": "お問い合わせ",
  
  // Testimonials Section
  "What Our Students Say": "生徒の声",
  "This is exactly what I was looking for! Learning English through BMX has made studying so much more enjoyable. The instructors really understand both languages and action sports.": "これはまさに私が探していたものです！BMXを通じて英語を学ぶことで、勉強がとても楽しくなりました。講師は言語とアクションスポーツの両方を本当に理解しています。",
  "Yuki Tanaka": "田中雄樹",
  "BMX Rider": "BMXライダー",
  "I've tried many English conversation schools, but this one is different. The skateboarding context makes everything click. My confidence in speaking English has improved dramatically.": "多くの英会話スクールを試しましたが、ここは違います。スケートボードの文脈ですべてが理解できます。英語を話す自信が劇的に向上しました。",
  "Sakura Yamamoto": "山本さくら",
  "Skateboarder": "スケートボーダー",
  "The community aspect is amazing. I've made friends from around the world who share my passion for action sports and learning English.": "海外のスケートパークで現地のライダーと自然に会話できるようになりました。英語で世界を自由にライドする力が身につきます！",
  "Hiroshi Sato": "佐藤寛",
  "Action Sports Enthusiast": "アクションスポーツ愛好家",
  
  // CTA Section
  "Ready to Start Your Journey?": "一緒にライディングも英語もレベルアップしませんか？",
  "Join thousands of action sports enthusiasts who are mastering English through their passion. Start your free trial today!": "ランプアップイングリッシュなら、英語で世界を自由にライドする力が身につきます！一緒にライディングも英語も、そして冒険もレベルアップさせましょう！",
  "Start Free Trial Today": "無料体験を予約する",
  "Contact Us": "お問い合わせ",
  
  // Footer
  "Action English": "ランプアップイングリッシュ",
  "Learn English through the exciting world of action sports": "アクションスポーツで英語を学ぶオンライン英会話スクール",
  "Quick Links": "クイックリンク",
  "About Us": "私たちについて",
  "Courses": "レッスン内容",
  "Pricing": "料金",
  "Blog": "ブログ",
  "Support": "サポート",
  "FAQ": "よくある質問",
  "Help Center": "ヘルプセンター",
  "Contact": "お問い合わせ",
  "Legal": "法的事項",
  "Privacy Policy": "プライバシーポリシー",
  "Terms of Service": "利用規約",
  "Follow Us": "フォローする",
  "© 2024 Action English. All rights reserved.": "© 2024 ランプアップイングリッシュ. All rights reserved.",
  
  // FAQ Section
  "Frequently Asked Questions": "よくある質問",
  "Is it one-on-one lessons?": "マンツーマンレッスンですか？",
  "Yes, it's one-on-one. We provide coaching not only during lessons but also create proper learning menus for daily study to help you become able to speak.": "マンツーマンです。レッスン中はもちろん、普段の学習面まできっちりメニューを作り、話せるようになるためのコーチングを行います。",
  "What payment methods are available?": "支払い方法は何がありますか？",
  "We accept bank transfer. Students are responsible for transfer fees.": "銀行振込でお願いしております。手数料は生徒さん負担でお願いしております。",
  "Are lesson days fixed?": "レッスンの曜日は固定ですか？",
  "Monday to Saturday, we set up classes from 10am to 9pm according to students' convenience.": "月曜から土曜、毎日10時~21時の間で生徒さんのご都合に合わせてクラスを設けております。",
  "How do I make reservations?": "予約方法は何がありますか？",
  "Please contact us through our official Instagram or email address, and we will adjust the schedule individually.": "公式インスタグラム、またはメールアドレスでお問い合わせ頂き、そこで個別にスケジュールを調整させて頂きます。",
  
  // About Instructor
  "About Our Instructor": "講師について",
  "Our instructor is from NY and grew up in Los Angeles from high school. He has been riding BMX and was previously sponsored by We The People and Madera BMX Company. After living in California for 10 years, he came to Japan and continues studying Japanese. He graduated from LBCC in California and holds a TEFL (Teaching English as a Foreign Language) qualification. He has been providing private English instruction online for one year. He studies Japanese daily and plans to obtain JLPT N2 by next year.": "講師は、NY出身で、高校からロサンゼルスで育ちました。BMXにずっと乗っていて、これまで We The People と Madera BMX Company にスポンサーされていました。カリフォルニアに10年間住んだ後、日本に来て日本語の勉強を続けています。カリフォルニアの LBCC を卒業しており、TEFL（外国語としての英語指導）資格を持っています。オンラインで1年間、プライベート英語指導も行ってきました。日本語は毎日勉強していて、来年までに JLPT N2 を取得する予定です。"
};

export default common;
